import React from "react";

import { ReactComponent as SortIcon } from "../../icons/sort.svg";
import "../../stylesheets/Sort.css";

const VtUserManagementSort = (props) => {
  const sortBy = (sortId) => {
    props.setSort({
      sortId: sortId,
      asc: props.sort.sortId === sortId ? !props.sort.asc : true,
    });
  };

  return (
    <tr id="sort">
      <td className="sorting" onClick={() => sortBy("email")}>
        <label htmlFor="vt-user-search">
          Email <SortIcon />
        </label>
      </td>
      <td className="sorting" onClick={() => sortBy("firstName")}>
        <label htmlFor="vt-user-search">
          First Name <SortIcon />
        </label>
      </td>
      <td className="sorting" onClick={() => sortBy("lastName")}>
        <label htmlFor="vt-user-search">
          Last Name <SortIcon />
        </label>
      </td>
      <td className="sorting" onClick={() => sortBy("status")}>
        <label htmlFor="vt-user-search">
          Status <SortIcon />
        </label>
      </td>
      <td>Actions</td>
    </tr>
  );
};

export default VtUserManagementSort;
